module.exports = __webpack_public_path__ + "img/game1.77de8e15.png";